import { React, useState, useEffect } from "react";
import { Markup } from "interweave";

function PrivacyPolicy(props) {
  const [dataHtml, setData] = useState(null);

  useEffect(() => {
    fetch("./privacy.html")
      .then((res) => res.text())
      .then((data) => {
        setData(data);
      })
      .catch((err) => console.log(err));
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="card-wrapper">
        <div className="card card-bg card-big roundedCustom no-after">
          <div className="card-body">
            <Markup content={dataHtml} />
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
